import React from "react";
import { render } from "react-dom";
import GamesFilterNavigation from "../components/GamesFilterNavigation.jsx";
import GamesFilterGames from "../components/GamesFilterGames.jsx";
import Gfyw from "../components/gfyw/gfyw.jsx";
import page from "page";
import ajaxError from "./ajaxError";
import log from "./log";

function gameFilter(ctx, next) {
	if (!paginationData.parsed && ctx.params.first) {
		paginationData.first = ctx.params.first;
		if (ctx.params.second) {
			paginationData.second = ctx.params.second;
		}
	}
	if (!ctx.params.second) {
		if (
			paginationData.parsed &&
			isNaN(ctx.params.page) &&
			$.inArray(
				ctx.canonicalPath.split("/")[ctx.canonicalPath.split("/").length - 1],
				[
					"#new",
					"#topRated",
					"#Today",
					"#ThisWeek",
					"#ThisMonth",
					"#AllTimes",
					"#sections",
					"#page"
				]
			) < 0
		) {
			log(__filename, "Entre Aquí 1");
			log(__filename, `${ctx.canonicalPath.split("/")}`);
			window.location = ctx.path;
			return;
		}
		if (ctx.canonicalPath.split("/")[1] == "#sections") {
			$("html,body").animate(
				{
					scrollTop: $(".Games-categorylist--four").offset().top - 16
				},
				1000
			);
			return;
		}
	} else if (
		paginationData.parsed &&
		isNaN(ctx.params.page) &&
		$.inArray(ctx.canonicalPath.split("/")[3], [
			"#new",
			"#topRated",
			"#Today",
			"#ThisWeek",
			"#ThisMonth",
			"#AllTimes",
			"#sections",
			"#page"
		]) < 0
	) {
		log(__filename, "Entre Aquí 2");
		window.location = ctx.path;
		return;
	}

	if (typeof ctx.params.page !== "undefined") {
		paginationData.page = ctx.params.page;
	}
	if (ctx.hash) {
		ctx.params.sortBy = ctx.hash;

		paginationData.sortBy = ctx.params.sortBy;
	}

	if (
		(ctx.params.sortBy != "" && !paginationData.parsed) ||
		(ctx.params.page != "1" && !paginationData.parsed) ||
		(paginationData.parsed && paginationData.second == ctx.params.second)
	) {
		if (
			new Date().getTime() - window.rendered.getTime() < 1000 &&
			$.inArray(ctx.canonicalPath.split("/")[3], [
				"#new",
				"#topRated",
				"#Today",
				"#ThisWeek",
				"#ThisMonth",
				"#AllTimes",
				"#sections"
			]) < 0
		) {
			paginationData.parsed = true;
			log(__filename, { paginationData });
			if (paginationData.sortBy == "page") {
				return;
			}
		}
		let relacionados = "";
		$(".Category-title").append(
			'<i class=" fa fa-circle-o-notch fa-spin fa-fw "></i>'
		);
		if (paginationData.games_related) {
			relacionados = $("#relacionados").html();
		}
		paginationData.mobile = false;
		log(__filename, { paginationData });
		log(__filename, "Fetching games");
		$.get(links.api.games, paginationData)
			.done(data => {
				if (paginationData.section != "gfyw") {
					render(
						<GamesFilterGames relacionados={relacionados} data={data.data} />,
						document.getElementById("GamesFilterGames")
					);
					if (paginationData.section != "homepage") {
						render(
							<GamesFilterNavigation
								page={paginationData.page}
								relacionados={relacionados}
								totalPages={paginationData.totalPages}
							/>,
							document.getElementById("GamesFilterNavigation")
						);
					}
				} else {
					render(
						<Gfyw {...data} />,
						document.getElementsByClassName("gfyw-container")[0]
					);
				}
			})
			.fail(ajaxError)
			.always(() => {
				$(".Category-title")
					.find(".fa")
					.remove();
			});
	}

	paginationData.parsed = true;
}

export default gameFilter;
